<ngx-loading [show]="showSpinner || !iwService.handshakeFinished"></ngx-loading>
<div class="wrapper">
    <div class="left">
        <img src="assets/images/incucai-logo.png" alt="" class="image" />
    </div>

    <div class="right">
        <div class="back"></div>

    <div class="title">
      {{ "login.Site" | translate }}
    </div>
    <div class="card">

            <div class="user-image"><i class="fa fa-user"></i></div>

            <div *ngIf="!iwService.handshakeFinished">
                {{ 'login.handShakeLoginWaitText' | translate }}
            </div>

            <form (ngSubmit)="onSubmit()" class="form" *ngIf="iwService.handshakeFinished">
                <app-button [disable]="submitting || !iwService.handshakeFinished" title="{{ 'login.LoginWallet' | translate }}"
                            primary="true" big="true" (buttonClick)="onSubmit()"></app-button>
            </form>
        </div>
    </div>
</div>
<ng-template #content let-modal>
    <div class="modal-header">
        <h4>Seleccionar Organización</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-group col-12 m-0">
        <form [formGroup]="form">
            <select class="form-control" [ngClass]="{ 'is-invalid': submitted && f.organization.errors }" formControlName="organization">
                <option [value]="0" disabled>-Organización (*)-</option>
                <option [ngValue]="organization.id" *ngFor="let organization of organizations">{{organization.name}}</option>
            </select>
            <div class="invalid-feedback">La organización es requerida.</div>
        </form>
    </div>
    <div class="modal-footer">
        <button *ngIf="form.controls['organization'].value" type="button" class="btn btn-outline-dark" (click)="select()">Aceptar</button>
    </div>
</ng-template>